import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export const GuideDownload = () => {
  const guideTopics = ['Dubai property buying process', 'Expected ROI by area', 'Golden Visa eligibility', 'Tax advantages', 'Best investment zones', 'Payment plans'];
  return <section id="guide" className="bg-gray-50 py-16 md:py-24 relative overflow-hidden" data-id="element-204">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#d8a34d] opacity-[0.03] rounded-full blur-3xl pointer-events-none translate-x-1/3 -translate-y-1/3" data-id="element-205"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-[#d8a34d] opacity-[0.03] rounded-full blur-3xl pointer-events-none -translate-x-1/3 translate-y-1/3" data-id="element-206"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-207">
        <div className="max-w-5xl mx-auto" data-id="element-208">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center" data-id="element-209">
            {/* Left Side: Book Mockup */}
            <div className="w-full lg:w-1/2" data-id="element-210">
              <div className="relative w-full max-w-sm mx-auto lg:mx-0 perspective-1000" data-id="element-211">
                <div className="relative w-full aspect-[3/4] rounded-r-xl rounded-l-sm bg-gradient-to-br from-[#1a2e1c] to-[#0f1f10] border border-[#d8a34d]/30 shadow-[20px_20px_40px_rgba(26,46,28,0.4),-5px_0_15px_rgba(216,163,77,0.1)] transform rotate-y-[-15deg] rotate-x-[5deg] transition-transform duration-500 hover:rotate-y-0 hover:rotate-x-0 group" data-id="element-212">
                  {/* Book Spine */}
                  <div className="absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-[#0f1f10] to-[#1a2e1c] rounded-l-sm border-r border-[#d8a34d]/20" data-id="element-213"></div>

                  {/* Book Cover Content */}
                  <div className="absolute inset-0 ml-4 p-6 md:p-8 flex flex-col justify-between" data-id="element-214">
                    <div data-id="element-215">
                      <div className="w-12 h-1 bg-[#d8a34d] mb-6" data-id="element-216"></div>
                      <h3 className="text-2xl md:text-3xl font-display font-bold text-white leading-snug" data-id="element-217">
                        Dubai Property
                        <br data-id="element-218" />
                        Investment Guide
                        <br data-id="element-219" />
                        <span className="text-[#d8a34d]" data-id="element-220">2026</span>
                      </h3>
                    </div>
                    <div data-id="element-221">
                      <p className="text-[#d8a34d] text-sm tracking-widest uppercase mb-2" data-id="element-222">
                        For Indian Investors
                      </p>
                      <div className="w-full h-px bg-[#d8a34d]/30" data-id="element-223"></div>
                    </div>
                  </div>

                  {/* Subtle reflection */}
                  <div className="absolute inset-0 ml-4 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-224"></div>
                </div>
              </div>
            </div>

            {/* Right Side: Copy & CTA */}
            <div className="w-full lg:w-1/2" data-id="element-225">
              <h2 className="text-3xl md:text-4xl font-display font-bold text-[#1a1a1a] leading-tight mb-8" data-id="element-226">
                Dubai Property Investment Guide for Indian Investors{' '}
                <span className="text-[#d8a34d]" data-id="element-227">(2026)</span>
              </h2>

              {/* Checklist */}
              <div className="space-y-3.5 mb-10" data-id="element-228">
                {guideTopics.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-229">
                    <CheckCircle2 className="w-4.5 h-4.5 text-[#d8a34d] flex-shrink-0" data-id="element-230" />
                    <span className="text-gray-600 text-sm md:text-base font-medium" data-id="element-231">
                      {item}
                    </span>
                  </div>)}
              </div>

              {/* CTA */}
              <a href="https://ikigaire.ae/wp-content/uploads/2026/03/WHY-DUBAI.pdf" target="_blank" rel="noopener noreferrer" className="btn-gold px-8 py-4 md:px-10 md:py-5 rounded-lg font-bold text-lg inline-block shadow-xl" data-id="element-232">
                Download Free Investor Guide
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};